import { CREATE_COMS_CONFIG, CREATE_COMS_CONFIG_SUCCESS, CREATE_COMS_CONFIG_ERROR, CREATE_COMS_CONFIG_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CreateComsConfig = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_COMS_CONFIG:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CREATE_COMS_CONFIG_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case CREATE_COMS_CONFIG_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CREATE_COMS_CONFIG_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CreateComsConfig;
